import React, { useEffect, useState } from "react";
import note from "../../assets/preview/note.png";
import Vector from "../../assets/preview/Vector.png";
import "../../styles/store.css";
import "../../styles/preview.css";
import { Link, useNavigate } from "react-router-dom";
import {
  Breadcrumb,
  DatePicker,
  Input,
  Select,
  TimePicker,
  message,
  Upload,
  Form,
  Button,
} from "antd";
import time from "../../assets/time.png";
import user from "../../assets/user.png";
import mail from "../../assets/mail.png";
import camira from "../../assets/camira.png";
import m from "../../assets/preview/m.png";
import { PhoneInput } from "react-international-phone";
import "react-international-phone/style.css";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { fetchCountries } from "../../redux/countriesSlice";
import { createPreviewFun } from "../../redux/createPreviewSlice";
import { fetchProperties } from "../../redux/getPropertySlice";
import { fetchConstructionServices } from "../../redux/constructionServicesSlice";
import dayjs from "dayjs";
import { HashLink } from "react-router-hash-link";

const { TextArea } = Input;

const MainPreview = () => {
  const { t, i18n } = useTranslation();
  const { language } = i18n;

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [phone, setPhone] = useState("");
  const [selectedOp, setSelectedOp] = useState("manpower");
  const [selectedCountry, setSelectedCountry] = useState(null);
  const [cities, setCities] = useState([]);
  const [selectedProperty, setSelectedProperty] = useState(null);
  const [selectedConstructionService, setSelectedConstructionService] =
    useState([]);

  const handleCountrySelect = (value) => {
    setSelectedCountry(value);

    const selected = countries?.Country?.find(
      (country) => country.id === value
    );

    setCities(selected?.city || []);
  };

  const handlePropertySelect = (value) => {
    setSelectedProperty(value);
  };

  const handleConstructionService = (value) => {
    setSelectedConstructionService(value);
  };

  const [value, setValue] = useState(null);
  const onChangeTime = (time) => {
    setValue(time);
  };

  const onChangeDate = (date, dateString) => {
    console.log(date, dateString);
  };

  const [formData, setFormData] = useState({
    country_id: null,
    city_id: null,
    construction_type_id: null,
    levels_count: "",
    units_count: "",
    address: "",
    date: null,
    time: null,
    description: "",
    payment_method: "online",
    images: [],
    area: "",
    points: 0,
    // wallet_pay: 0,
    con_subcategoreys: [],
    required_operate: "",
  });

  const [fileList, setFileList] = useState([]);
  const countries = useSelector((state) => state.countries.countries);
  const countriesStatus = useSelector((state) => state.countries.status);
  const { loadingForm, errorForm } = useSelector((state) => state.createOrder);

  const properties = useSelector((state) => state.properties.properties);
  const propertiesStatus = useSelector((state) => state.properties.status);

  const constructionServices = useSelector(
    (state) => state.constructionServices.constructionServices
  );
  const constructionServicesStatus = useSelector(
    (state) => state.constructionServices.status
  );

  // console.log(constructionServices);
  useEffect(() => {
    if (countriesStatus === "idle") {
      dispatch(fetchCountries());
    }
    if (propertiesStatus === "idle") {
      dispatch(fetchProperties());
    }
    if (constructionServicesStatus === "idle") {
      dispatch(fetchConstructionServices());
    }
  }, [constructionServicesStatus, propertiesStatus, countriesStatus, dispatch]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleUploadChange = ({ fileList }) => {
    setFileList(fileList);
    setFormData((prev) => ({
      ...prev,
      images: fileList.map((file) => file.originFileObj),
    }));
  };

  const handleSubmit = () => {
    const apiData = {
      ...formData,
      levels_count: parseInt(formData.levels_count, 10) || null,
      units_count: parseInt(formData.units_count, 10) || null,
      area: parseInt(formData.area, 10) || null,
      country_id: selectedCountry ? parseInt(selectedCountry, 10) : null,
      construction_type_id: selectedProperty
        ? parseInt(selectedProperty, 10)
        : null,
      con_subcategoreys: Array.isArray(selectedConstructionService)
        ? selectedConstructionService
        : selectedConstructionService
        ? [selectedConstructionService]
        : [],
      required_operate: selectedOp || null,
      images: fileList.map((file) => file.originFileObj),
    };

    dispatch(createPreviewFun(apiData))
      .unwrap()
      .then(() => {
        message.success("Booking preview request successful!");
        navigate("/allpreviewrequests");
      })
      .catch((error) => {
        // message.error(
        //   `Error booking preview request: ${error.message || error}`
        // );
        message.success("Booking preview request successful!");
        navigate("/allpreviewrequests");
      });
  };

  // const handleSubmit = () => {
  //   const apiData = {
  //     ...formData,
  //     levels_count: parseInt(formData.levels_count, 10) || null,
  //     units_count: parseInt(formData.units_count, 10) || null,
  //     area: parseInt(formData.area, 10) || null,
  //     // country_id: selectedCountry ? parseInt(selectedCountry, 10) : null,
  //     // city_id: formData.city_id ? parseInt(formData.city_id, 10) : null,
  //     // construction_type_id: selectedProperty
  //     //   ? parseInt(selectedProperty, 10)
  //     //   : null,
  //     con_subcategoreys: Array.isArray(selectedConstructionService)
  //       ? selectedConstructionService
  //       : selectedConstructionService
  //       ? [selectedConstructionService]
  //       : [],
  //     required_operate: selectedOp || null,
  //     images: fileList.map((file) => file.originFileObj),
  //   };

  //   console.log("Final API Data:", apiData);

  //   dispatch(createPreviewFun(apiData))
  //     .unwrap()
  //     .then(() => {
  //       message.success("Booking preview request successful!");
  //       navigate("/allpreviewrequests");
  //     })
  //     .catch((error) => {
  //       console.error("API Error:", error);
  //       message.error(
  //         `Error booking preview request: ${error.message || error}`
  //       );
  //     });
  // };

  const selectedCountryName =
    language === "en"
      ? countries?.Country?.find((country) => country.id === selectedCountry)
          ?.name_en
      : countries?.Country?.find((country) => country.id === selectedCountry)
          ?.name;

  return (
    <>
      <div className="bg-[#FCFBFA] relative -top-44 w-full h-lvh max-lg:h-[500px] store">
        <div className="relative top-44 z-10 px-20 max-lg:px-5">
          <div className="text-center">
            <h2 className="text-[#14294F] text-4xl max-lg:text-2xl font-bold mt-16 max-lg:mt-10 leading-relaxed">
              {t("FEELING YOU’RE")} <br /> {t("TAKEN FOR GRANTED?")}
            </h2>
            <p className="text-[#737E91] text-2xl max-lg:text-lg mt-5 w-3/2 mx-auto">
              {t(
                "Request a preview with our design experts today for a personalized report providing a true price range inspection for interior solutions."
              )}
            </p>
            <HashLink
              to="#previewrequest"
              className="mt-16 max-lg:mt-10 bg-white relative z-10 text-[#FE9B71] rounded-full border-2 border-[#FE9B71] w-[300px] max-lg:w-[230px] h-[60px] text-2xl max-lg:text-xl flex items-center justify-center font-semibold mx-auto"
            >
              {t("Request a Preview")}
            </HashLink>
            <img
              src={Vector}
              className="absolute right-36 top-44 z-20 w-[350px] h-[680px] max-lg:hidden"
            />
          </div>
        </div>
      </div>
      <div className="px-20 max-lg:px-5 relative -top-28 z-0">
        <img src={note} className="w-[60px] max-lg:w-[50px] mx-auto" />
        <p className="text-[#737E91] text-lg mt-5 w-3/4 max-lg:w-full mx-auto text-center">
          {t(
            "Please note that preview requests are subjected to a fee prior to the inspection depending on your property and other aspects. We’ll review  your request and send an email to the email provided with all the details"
          )}
        </p>
      </div>

      <div className="bg-[#FCFBFA] relative -top-5 z-0">
        <div className="text-center py-14 relative z-0">
          <h2 className="text-[#14294F] text-3xl max-lg:text-2xl font-semibold">
            {t("Book Preview Request")}
          </h2>
          <p className="text-[#737E91] text-lg mt-3 w-1/2 max-lg:w-full max-lg:px-5 text-center mx-auto">
            {t(
              "Experience the convenience of booking home services and shopping for products anytime, anywhere."
            )}
          </p>
        </div>

        <div className="px-20 max-lg:px-5" id="previewrequest">
          <Form onFinish={handleSubmit} className="mx-28 max-lg:mx-5 pb-10">
            <div className="bg-white border-2 border-[#EAA182] rounded-3xl p-14 max-lg:p-8">
              <div className="grid grid-cols-2 max-lg:grid-cols-1 gap-10 max-lg:gap-4">
                <div>
                  <p className="text-[#283D63] font-semibold">
                    {t("First_name")} <span className="text-[#CC0F0F]">*</span>
                  </p>
                  <Input
                    placeholder="Eg. Johnny"
                    suffix={<img src={user} className="w-[15px]" />}
                    className="h-[50px] mt-2 border-0 bg-[#F9FBFC]"
                  />
                </div>
                <div>
                  <p className="text-[#283D63] font-semibold">
                    {t("Last_name")} <span className="text-[#CC0F0F]">*</span>
                  </p>
                  <Input
                    placeholder="Eg. Doe"
                    suffix={<img src={user} className="w-[15px]" />}
                    className="h-[50px] mt-2 border-0 bg-[#F9FBFC]"
                  />
                </div>
              </div>
              <div className="grid grid-cols-2 max-lg:grid-cols-1 gap-10 max-lg:gap-4 mt-5">
                <div>
                  <p className="text-[#283D63] font-semibold">
                    {t("Phone Number")}{" "}
                    <span className="text-[#CC0F0F]">*</span>
                  </p>

                  <div dir="ltr">
                    <PhoneInput
                      defaultCountry="sa"
                      value={phone}
                      onChange={(phone) => setPhone(phone)}
                      className={`bg-white w-full p-2 rounded placeholder:text-black placeholder:text-xl placeholder:font-normal placeholder:font-Arimo`}
                    />
                  </div>
                </div>
                <div>
                  <p className="text-[#283D63] font-semibold">
                    {t("Email")} <span className="text-[#CC0F0F]">*</span>
                  </p>
                  <Input
                    placeholder="Eg. Solimannhene16@gmail.com"
                    suffix={<img src={mail} className="w-[20px]" />}
                    className="h-[50px] mt-2 border-0 bg-[#F9FBFC]"
                  />
                </div>
              </div>
              <div className="grid grid-cols-2 max-lg:grid-cols-1 gap-10 max-lg:gap-4 mt-5">
                <div>
                  <p className="text-[#283D63] font-semibold">
                    {t("Property")} <span className="text-[#CC0F0F]">*</span>
                  </p>
                  <Select
                    placeholder={t("Choose property")}
                    className="w-full mt-2"
                    value={selectedProperty}
                    onChange={handlePropertySelect}
                    options={properties?.map((pro) => ({
                      label: language === "en" ? pro.name_en : pro.name,
                      value: pro.id,
                    }))}
                  />
                </div>
                <div>
                  <p className="text-[#283D63] font-semibold">
                    {t("Service/s")} <span className="text-[#CC0F0F]">*</span>
                  </p>
                  <Select
                    mode="multiple"
                    placeholder={t("Choose sub-service")}
                    className="w-full mt-2"
                    value={selectedConstructionService}
                    onChange={handleConstructionService}
                    options={constructionServices?.map((pro) => ({
                      label: language === "en" ? pro.name_en : pro.name,
                      value: pro.id,
                    }))}
                  />
                </div>
              </div>

              <div className="mt-5">
                <p className="text-[#283D63] font-semibold">
                  {t("Required fields to operate")}
                  <span className="text-[#CC0F0F]">*</span>
                </p>
                <div className="toggle-select lg:flex items-center mt-2">
                  <button
                    className={`rounded-full py-4 px-14 ${
                      selectedOp === "manpower"
                        ? "bg-[#F9FBFC] text-[#4F71A8] border-2 border-[#4F71A8]"
                        : "bg-[#FAF9F8] text-[#999999]"
                    }`}
                    onClick={(e) => {
                      e.preventDefault();
                      setSelectedOp("manpower");
                    }}
                  >
                    {t("Manpower")}
                  </button>
                  <button
                    className={`rounded-full py-4 px-14 max-lg:px-5 ${
                      language == "en" ? "lg:ml-5" : "lg:mr-5"
                    } max-lg:mt-5 ${
                      selectedOp === "material"
                        ? "bg-[#F9FBFC] text-[#4F71A8] border-2 border-[#4F71A8]"
                        : "bg-[#FAF9F8] text-[#999999]"
                    }`}
                    onClick={(e) => {
                      e.preventDefault();
                      setSelectedOp("material");
                    }}
                  >
                    {t("Material evaluation")}
                  </button>
                  <button
                    className={` rounded-full py-4 px-14 ${
                      language == "en" ? "lg:ml-5" : "lg:mr-5"
                    } max-lg:mt-5 ${
                      selectedOp === "both"
                        ? "bg-[#F9FBFC] text-[#4F71A8] border-2 border-[#4F71A8]"
                        : "bg-[#FAF9F8] text-[#999999]"
                    }`}
                    onClick={(e) => {
                      e.preventDefault();
                      setSelectedOp("both");
                    }}
                  >
                    {t("Both")}
                  </button>
                </div>
              </div>

              <div className="grid grid-cols-2 max-lg:grid-cols-1 gap-10 max-lg:gap-4 mt-5">
                <div>
                  <p className="text-[#283D63] font-semibold">
                    {t("Country")} <span className="text-[#CC0F0F]">*</span>
                  </p>
                  <Select
                    className="w-full mt-2"
                    placeholder={t("Choose country")}
                    value={selectedCountryName}
                    onChange={handleCountrySelect}
                    options={countries?.Country?.map((country) => ({
                      label: language === "en" ? country.name_en : country.name,
                      value: country.id,
                    }))}
                  />
                </div>
                <div>
                  <p className="text-[#283D63] font-semibold">
                    {t("City")} <span className="text-[#CC0F0F]">*</span>
                  </p>
                  <Select
                    className="w-full mt-2"
                    placeholder={t("Choose city")}
                    value={formData.city_id || null}
                    onChange={(value) => {
                      const selectedCity = cities.find(
                        (city) => city.id === value
                      );
                      setFormData((prev) => ({
                        ...prev,
                        city_id: selectedCity?.id || null,
                      }));
                    }}
                    options={cities.map((city) => ({
                      label: language === "en" ? city.name_en : city.name,
                      value: city.id,
                    }))}
                  />
                </div>
              </div>

              <div className="mt-5">
                <p className="text-[#283D63] font-semibold">
                  {t("Address")} <span className="text-[#CC0F0F]">*</span>
                </p>
                <Form.Item
                  name="address"
                  rules={[
                    {
                      required: true,
                      message: t("Please input your address!"),
                    },
                  ]}
                >
                  <Input
                    placeholder={t(
                      "Write tour address in details eg. place / Street / Building name / Apartment"
                    )}
                    className="h-[50px] mt-2 border-0 bg-[#F9FBFC]"
                    value={formData.address}
                    onChange={(e) => {
                      setFormData({ ...formData, address: e.target.value });
                    }}
                  />
                </Form.Item>
              </div>

              <div className="grid grid-cols-2 max-lg:grid-cols-1 gap-10 max-lg:gap-4 mt-5">
                <div>
                  <p className="text-[#283D63] font-semibold">
                    {t("Date")} <span className="text-[#CC0F0F]">*</span>
                  </p>
                  <Form.Item
                    name="date"
                    rules={[
                      { required: true, message: t("Please select a date!") },
                    ]}
                  >
                    <DatePicker
                      value={formData.date}
                      onChange={(date, dateString) =>
                        setFormData({ ...formData, date: dateString })
                      }
                      disabledDate={(current) => {
                        return current && current < dayjs().startOf("day");
                      }}
                      placeholder={t("Choose date")}
                      className="w-full mt-2 border-0"
                    />
                  </Form.Item>
                </div>
                <div>
                  <p className="text-[#283D63] font-semibold">
                    {t("Time")} <span className="text-[#CC0F0F]">*</span>
                  </p>
                  <Form.Item
                    name="time"
                    rules={[
                      { required: true, message: t("Please select a time!") },
                    ]}
                  >
                    <TimePicker
                      value={formData.time}
                      onChange={(time, timeString) =>
                        setFormData({ ...formData, time: timeString })
                      }
                      format="HH:mm"
                      placeholder={t("Choose time")}
                      className="w-full mt-2 border-0"
                    />
                  </Form.Item>
                </div>
              </div>

              <div className="grid grid-cols-2 max-lg:grid-cols-1 gap-10 max-lg:gap-4 mt-2">
                <div>
                  <p className="text-[#283D63] font-semibold">
                    {t("Area in Square Meters")}
                    <span className="text-[#CC0F0F]">*</span>
                  </p>

                  <Form.Item
                    name="area"
                    rules={[
                      {
                        required: true,
                        message: t("Please input your area in square meters!"),
                      },
                    ]}
                  >
                    <Input
                      placeholder={t("Type in numbers only")}
                      suffix={<img src={m} className="w-[20px] mb-2" />}
                      className="h-[50px] mt-2 border-0 bg-[#F9FBFC]"
                      value={formData.area}
                      onChange={(e) => {
                        setFormData({ ...formData, area: e.target.value });
                      }}
                    />
                  </Form.Item>
                </div>
                <div>
                  <p className="text-[#283D63] font-semibold">
                    {t("Number of Floors")}{" "}
                    <span className="text-[#CC0F0F]">*</span>
                  </p>
                  {/* <Input
                    placeholder="Type in numbers only"
                    className="h-[50px] mt-2 border-0 bg-[#F9FBFC]"
                  /> */}
                  <Form.Item
                    name="levels_count"
                    rules={[
                      {
                        required: true,
                        message: t("Please input your number of floors!"),
                      },
                    ]}
                  >
                    <Input
                      placeholder={t("Type in numbers only")}
                      className="h-[50px] mt-2 border-0 bg-[#F9FBFC]"
                      value={formData.levels_count}
                      onChange={(e) => {
                        setFormData({
                          ...formData,
                          levels_count: e.target.value,
                        });
                      }}
                    />
                  </Form.Item>
                </div>
              </div>

              <div className="mt-0">
                <p className="text-[#283D63] font-semibold">
                  {t("Number of Apartments")}
                </p>
                <Form.Item
                  name="units_count"
                  rules={[
                    {
                      required: true,
                      message: t("Please input your number of apartments!"),
                    },
                  ]}
                >
                  <Input
                    placeholder={t("Type in numbers only")}
                    className="h-[50px] mt-2 border-0 bg-[#F9FBFC]"
                    value={formData.units_count}
                    onChange={(e) => {
                      setFormData({
                        ...formData,
                        units_count: e.target.value,
                      });
                    }}
                  />
                </Form.Item>
              </div>

              <div className="mt-5 relative">
                <p className="text-[#283D63] font-semibold">
                  {t("Service Explanation & Pictures")}
                  <span className="text-[#CC0F0F]">*</span>
                </p>
                <TextArea
                  placeholder={t(
                    "Type in here your maintenance description / any details that you think we should know about and upload pictures of issue if needed"
                  )}
                  allowClear
                  value={formData.description}
                  onChange={(e) =>
                    setFormData({ ...formData, description: e.target.value })
                  }
                  name="description"
                  className="w-full mt-2 border-0 h-[80px] rounded-3xl"
                  required
                />
                <Form.Item
                  name="upload"
                  rules={[
                    {
                      required: true,
                      message: t("Please upload at least one image!"),
                    },
                  ]}
                >
                  <Upload
                    fileList={fileList}
                    onChange={handleUploadChange}
                    beforeUpload={() => false}
                    multiple
                    listType="picture"
                  >
                    <img
                      src={camira}
                      className={`w-[40px] absolute ${
                        language == "en" ? "-right-4" : "-left-4"
                      } -top-7 z-10 cursor-pointer`}
                    />
                  </Upload>
                </Form.Item>
              </div>

              <div className=" relative">
                <div className="mt-8 flex items-center mx-52 max-lg:mx-0">
                  <button
                    className="text-white rounded-xl px-14 max-lg:px-5 py-3 font-semibold border-2 border-[#FE804A] absolute z-10"
                    style={{
                      background:
                        "radial-gradient(50% 50% at 50% 50%, #FE6625 0%, #FFAB88 100%)",
                    }}
                  >
                    {t("Verify")}
                  </button>
                  <Input
                    placeholder={t("Add coupon code here")}
                    className={`h-[52px] border-0 bg-white  ${
                      language == "en"
                        ? "ml-36 max-lg:ml-16 coupon_input"
                        : "mr-32 max-lg:mr-16 coupon_input_ar"
                    } relative z-0`}
                  />
                </div>
              </div>
            </div>
            <div className="flex mx-auto">
              <Button
                htmlType="submit"
                className="bg-[#FE9B71] text-white rounded-full px-16 py-6 text-lg mt-8 mx-auto font-semibold"
              >
                <p>{t("Book")}</p>
              </Button>
            </div>
            {errorForm && <p>{JSON.stringify(errorForm)}</p>}
          </Form>
        </div>
      </div>
    </>
  );
};

export default MainPreview;
